import { render, staticRenderFns } from "./Qualita.vue?vue&type=template&id=1cd614ae&"
import script from "./Qualita.vue?vue&type=script&lang=js&"
export * from "./Qualita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports